/* Mirelia · Maenner-PDP
   Navigation unter einer .mm-rail: Pfeil links, Punkte, Pfeil rechts.
   Die Punkte baut das Skript selbst aus der Zahl der Karten.
   Sie erscheint nur, solange die Reihe wirklich seitlich scrollt
   (am Rechner wird aus der Reihe ein Raster, dann bleibt sie weg). */
(function () {
  if (window.__mmRail) return;
  window.__mmRail = true;

  function reiheZu(nav) {
    var v = nav.previousElementSibling;
    while (v && !v.classList.contains('mm-rail')) v = v.previousElementSibling;
    return v || nav.parentElement.querySelector('.mm-rail');
  }

  /* Eigene Animation: scrollTo mit behavior:'smooth' laeuft auf
     verschachtelten Behaeltern nicht zuverlaessig. */
  function schieben(reihe, ziel, nach) {
    if (reihe.__lauf) cancelAnimationFrame(reihe.__lauf);
    if (reihe.__wecker) clearTimeout(reihe.__wecker);
    var start = reihe.scrollLeft;
    var weg = ziel - start;
    var dauer = 280;
    if (Math.abs(weg) < 2) { reihe.scrollLeft = ziel; if (nach) nach(); return; }
    var t0 = null;
    function schritt(t) {
      if (t0 === null) t0 = t;
      var p = Math.min((t - t0) / dauer, 1);
      reihe.scrollLeft = start + weg * (1 - Math.pow(1 - p, 3));
      if (nach) nach();
      reihe.__lauf = p < 1 ? requestAnimationFrame(schritt) : null;
    }
    reihe.__lauf = requestAnimationFrame(schritt);
    reihe.__wecker = setTimeout(function () {
      if (reihe.__lauf) cancelAnimationFrame(reihe.__lauf);
      reihe.__lauf = null;
      reihe.scrollLeft = ziel;
      if (nach) nach();
    }, dauer + 90);
  }

  function aufbauen(nav) {
    var reihe = reiheZu(nav);
    if (!reihe) return;
    var karten = [].slice.call(reihe.children);
    if (karten.length < 2) return;

    var punkteFeld = nav.querySelector('[data-rail-punkte]');
    var zurueck = nav.querySelector('[data-rail-zurueck]');
    var vor = nav.querySelector('[data-rail-vor]');
    var punkte = [];

    karten.forEach(function (karte, i) {
      var p = document.createElement('button');
      p.type = 'button';
      p.className = 'mm-railnav__punkt';
      p.setAttribute('aria-label', 'Zu Eintrag ' + (i + 1));
      p.addEventListener('click', function () { zuKarte(i); });
      punkteFeld.appendChild(p);
      punkte.push(p);
    });

    /* Alles ueber Bildschirmrechtecke rechnen. offsetLeft bezieht sich auf den
       naechsten positionierten Vorfahren, nicht auf die Reihe selbst, und passt
       damit nicht zu scrollLeft. */
    function mitteVon(el) {
      var r = el.getBoundingClientRect();
      return r.left + r.width / 2;
    }

    function aktiv() {
      var ziel = mitteVon(reihe);
      var beste = 0, abstand = Infinity;
      karten.forEach(function (k, i) {
        var d = Math.abs(mitteVon(k) - ziel);
        if (d < abstand) { abstand = d; beste = i; }
      });
      return beste;
    }

    function zuKarte(i) {
      i = Math.max(0, Math.min(karten.length - 1, i));
      var versatz = mitteVon(karten[i]) - mitteVon(reihe);
      var ziel = reihe.scrollLeft + versatz;
      /* malen direkt mitlaufen lassen: manche Umgebungen liefern beim
         programmatischen Scrollen keine scroll-Ereignisse. */
      schieben(reihe, Math.max(0, Math.min(ziel, reihe.scrollWidth - reihe.clientWidth)), malen);
    }

    function malen() {
      var scrollt = reihe.scrollWidth > reihe.clientWidth + 4;
      nav.hidden = !scrollt;
      if (!scrollt) return;
      var i = aktiv();
      punkte.forEach(function (p, n) { p.classList.toggle('is-an', n === i); });
      zurueck.disabled = reihe.scrollLeft <= 2;
      vor.disabled = reihe.scrollLeft >= reihe.scrollWidth - reihe.clientWidth - 2;
    }

    zurueck.addEventListener('click', function () { zuKarte(aktiv() - 1); });
    vor.addEventListener('click', function () { zuKarte(aktiv() + 1); });

    var wartet;
    reihe.addEventListener('scroll', function () {
      clearTimeout(wartet);
      wartet = setTimeout(malen, 70);
    }, { passive: true });
    window.addEventListener('resize', malen);
    malen();
    [400, 1200].forEach(function (t) { setTimeout(malen, t); });
  }

  function start(wurzel) {
    (wurzel || document).querySelectorAll('[data-railnav]:not([data-fertig])').forEach(function (nav) {
      nav.setAttribute('data-fertig', '1');
      aufbauen(nav);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(document); });
  } else {
    start(document);
  }
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
